module.exports = __webpack_public_path__ + "assets/0f71399e89b8c5c761de582c318075f3.svg";